/**
 * Control Plane Onboarding API Client
 * Handles onboarding missions + credits endpoints on control.zaviago.com
 */

import { cpGuestApiCall, getCPToken } from './controlPlaneClient'

// ── Types matching API contract (Epic 02) ──────────────────────────

export interface Mission {
  mission_key: string
  title: string
  description: string
  icon: string
  credits_reward: number
  completed: boolean
  completed_at: string | null
  target_route: string
  sort_order: number
}

export interface MissionSummary {
  total_missions: number
  completed_count: number
  current_balance: number
  lifetime_earned: number
  dismissed_at: string | null
  first_seen_at: string | null
}

export interface OnboardingMissionResponse {
  missions: Mission[]
  summary: MissionSummary
}

// ── API Functions ──────────────────────────────────────────────────

export async function cpGetMissionStatus(): Promise<OnboardingMissionResponse> {
  const token = getCPToken()
  return cpGuestApiCall<OnboardingMissionResponse>(
    'control_plane.api.onboarding.get_mission_status',
    { method: 'POST', body: JSON.stringify({ access_token: token }) }
  )
}

export async function cpCheckAndCompleteMissions(): Promise<OnboardingMissionResponse> {
  const token = getCPToken()
  return cpGuestApiCall<OnboardingMissionResponse>(
    'control_plane.api.onboarding.check_and_complete_missions',
    { method: 'POST', body: JSON.stringify({ access_token: token }) }
  )
}

export async function cpDismissWidget(): Promise<{ success: boolean }> {
  const token = getCPToken()
  return cpGuestApiCall<{ success: boolean }>(
    'control_plane.api.onboarding.dismiss_widget',
    { method: 'POST', body: JSON.stringify({ access_token: token }) }
  )
}

export async function cpResetDismissWidget(): Promise<{ success: boolean }> {
  const token = getCPToken()
  return cpGuestApiCall<{ success: boolean }>(
    'control_plane.api.onboarding.reset_dismiss_widget',
    { method: 'POST', body: JSON.stringify({ access_token: token }) }
  )
}
